var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qb-wrapper"},[_c('button',{staticClass:"qb-trigger-btn",style:(_vm.bgStyle),attrs:{"aria-label":"Quick Bet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }